/**
 * Busca el índice de un elemento en un arreglo de objetos por una clave específica.
 * Devuelve -1 si no se encuentra o si los datos no son válidos.
 */
export function getIndexElement(array, key, element) {
    if (!Array.isArray(array) || !key || typeof element !== 'string') {
        return -1;
    }

    return array.findIndex(obj => {
        return String(obj[key]).toUpperCase() === element.toUpperCase();
    });
}

export function getIndexElement2(array, key1,key2, element1,element2){
    let index=-1
    if(element1&&element2){
     index = array.findIndex(code => {  
        return ((String(code[key1]).toUpperCase() === String(element1).toUpperCase())&&(String(code[key2]).toUpperCase() === String(element2).toUpperCase()))
    })
}

    return index
}


export default {getIndexElement}